

export const RecipeModal = ({data}) => {
    const {name, img, recipe, ingredients} = data;
    return (
        <div className="modal fade" id="exampleModal"  aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                <div className="modal-header">
                    {img && (
                            <div className="col">
                                <img src={img} alt="" style={ {width: "100px"}}/>
                            </div>
                        )    
                    }
                    <div className="col">
                        <div className="name">
                            {name}
                        </div>
                    </div>
                    <div className="col-2 d-flex justify-content-end">
                        <button type="button" className="btn-close me-2" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">Cкладові</th>
                                        <th scope="col">Кількість</th>
                                    
                                    </tr>
                                </thead>
                                <tbody>
                                    {data && data.ingredients && ingredients.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <th>{item[0]}</th>
                                                <td>{item[1]}</td>
                                            </tr>
                                        )
                                    })}
                                    
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="row">
                                <div className="col">
                                    <p><strong>Спосіб приготування</strong></p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <p>{recipe}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Зрозуміло</button>
                </div>
                </div>
            </div>
        </div>
    )
}